import { formatDate } from '../../../../../../../shared/common/utils/formatDate';

export const getButtonLabel = (from: Date | null, to: Date | null): string => {
  if (!from || !to) {
    return 'Выберите даты';
  }

  const today = new Date();
  const isSameYear = from.getFullYear() === to.getFullYear();
  const isCurrentYear = from.getFullYear() === today.getFullYear();
  const shouldPrintYear = !isSameYear || !isCurrentYear;

  return `${formatDate(from, shouldPrintYear, true)} — ${formatDate(to, shouldPrintYear, true)}`;
};
